"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.enviarLinkPagamento = exports.update = exports.createPorToken = exports.create = exports.findOne = exports.findInscricaoPorToken = exports.findAllInscricaoAtiva = exports.findAllMinhas = exports.findAll = void 0;
const core_1 = require("./core");
const search_1 = require("./search");
function findAll(page = 1, search) {
    const encodedSearch = search_1.encodeSearchValues(search);
    return core_1.get('EventoInscricao', 'lista', Object.assign({ pg: page }, encodedSearch))
        .then(({ dados, paginacao }) => {
        if (dados.length === 0)
            return {
                elements: [],
                elementsPerPage: 0,
                totalElements: 0,
                currentPage: 0,
                totalPages: 0
            };
        return {
            elements: dados,
            elementsPerPage: paginacao.totalRegPorPagina,
            totalElements: paginacao.totalRegEncontrados,
            currentPage: paginacao.pagAtual,
            totalPages: paginacao.qtdPag
        };
    });
}
exports.findAll = findAll;
function findAllMinhas(page = 1, search) {
    const encodedSearch = search_1.encodeSearchValues(search);
    return core_1.get('EventoInscricao', 'listaMinhas', Object.assign({ pg: page }, encodedSearch))
        .then(({ dados, paginacao }) => {
        if (dados.length === 0)
            return {
                elements: [],
                elementsPerPage: 0,
                totalElements: 0,
                currentPage: 0,
                totalPages: 0
            };
        return {
            elements: dados,
            elementsPerPage: paginacao.totalRegPorPagina,
            totalElements: paginacao.totalRegEncontrados,
            currentPage: paginacao.pagAtual,
            totalPages: paginacao.qtdPag
        };
    });
}
exports.findAllMinhas = findAllMinhas;
function findAllInscricaoAtiva(page = 1, search) {
    const encodedSearch = search_1.encodeSearchValues(search);
    return core_1.get('EventoInscricao', 'listaInscricaoAtiva', Object.assign({ pg: page }, encodedSearch))
        .then(({ dados, paginacao }) => {
        if (dados.length === 0)
            return {
                elements: [],
                elementsPerPage: 0,
                totalElements: 0,
                currentPage: 0,
                totalPages: 0
            };
        return {
            elements: dados,
            elementsPerPage: paginacao.totalRegPorPagina,
            totalElements: paginacao.totalRegEncontrados,
            currentPage: paginacao.pagAtual,
            totalPages: paginacao.qtdPag
        };
    });
}
exports.findAllInscricaoAtiva = findAllInscricaoAtiva;
function findInscricaoPorToken(idEventoEdicao) {
    return core_1.get('EventoInscricao', 'listaPorToken', {
        idEventoEdicao
    })
        .then(({ dados, token }) => {
        return {
            token,
            current: dados[0]
        };
    });
}
exports.findInscricaoPorToken = findInscricaoPorToken;
function findOne(id) {
    return core_1.get('EventoInscricao', 'detalhe', { id });
}
exports.findOne = findOne;
function create(data) {
    return core_1.post('EventoInscricao', 'cadastro', data);
}
exports.create = create;
function createPorToken(data) {
    return core_1.post('EventoInscricao', 'cadastroPorToken', data);
}
exports.createPorToken = createPorToken;
function update(id, data) {
    return core_1.put('EventoInscricao', 'update', Object.assign({ id }, data));
}
exports.update = update;
function enviarLinkPagamento(id, data) {
    return core_1.post('EventoInscricao', 'enviarLinkPagamento', Object.assign({ id }, data));
}
exports.enviarLinkPagamento = enviarLinkPagamento;
function remove(id) {
    return core_1.del('EventoInscricao', 'exclui', { id });
}
exports.remove = remove;
